import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getPartnerAgent, updatePartnerAgent } from '../actions/partneragentActions'
import Country from '../components/Country'
import Header from '../components/Header'
import LeftComponent from '../components/LeftComponent'
import { PARTNER_AGENT_GET_RESET, PARTNER_AGENT_UPDATE_RESET } from '../constants/partnerAgentConstants'
import { partneragentJson } from '../models/partneragentModel'

export default function PartnerAgentEditScreen(props) {
    const { id } = useParams();
    const dispatch = useDispatch();

    const [parameters, setParameters] = useState(partneragentJson);

    const [executed, setExecuted] = useState(0);
    const [executedtime, setexecutedtime] = useState(0);

    const partnerAgentDetails = useSelector(state => state.partnerAgentDetails)
    const { loading: loadingDetail, error: errorDetail, partneragent } = partnerAgentDetails

    const partnerAgentUpdate = useSelector(state => state.partnerAgentUpdate)
    const { loading: loadingUpdate, error: errorUpdate, success: successUpdate } = partnerAgentUpdate

    const handleValue = (e) => {
        setParameters({ ...parameters, [e.target.name]: e.target.value });
    }

    const UpdateRecord = (e) => {
        dispatch(updatePartnerAgent(id, parameters))
        //console.log(parameters)
        //dispatch(getAffiliatePartner(id))
        setExecuted(0)
        setexecutedtime(1)
    }

    useEffect(() => {
        if (successUpdate) {
            setTimeout(() => {
                dispatch({
                    type: PARTNER_AGENT_UPDATE_RESET
                })
            }, 10000);
        }

        if(executed == 0){
            dispatch({
                type: PARTNER_AGENT_GET_RESET
            })
            setExecuted(1)
        }

        if(partneragent == undefined || partneragent.length == 0){
            setexecutedtime(executedtime + 1)
            if(executedtime < 5 && executedtime > 0){
                dispatch(getPartnerAgent(id))
            }else if(executedtime < 8){
                
            }
        }else{
            setParameters(partneragent[0])
        }
        // if (id != undefined) {
        //     if (college == undefined || college.length == 0) {
        //         dispatch(detailColleges(id))
        //     }
        //     else {
        //         setClg(college[0])
        //     }
        // }
    }, [dispatch, id, partneragent, successUpdate])

    return (
        <>
            <Header pageName="Edit Partner Agent" />
            <LeftComponent />
            <div className="content-body">
                <div className="container-fluid">
                    <div className="heading-title">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="home-title float-left">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="inner-body">
                        <div className="invoice-details">
                            <div className="container">
                                <div id="InvoiceAccordion" className="accordion-invoice">
                                    <div className="card mb-0">
                                        <div className="card-header collapsed" data-toggle="collapse" href="#collapseOne">
                                            <a className="card-title">
                                                Partner Agent Details
                                            </a>
                                        </div>

                                        <div className="card-body collapse show"  >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Partner Agent Name* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="partner agent name"
                                                                name="Partner_Agent"
                                                                value={parameters.Partner_Agent}
                                                                onChange={e => handleValue(e)} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Partner Agent Address* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            {/* <div className="input-group-prepend">
                                                                <span className="input-group-text">$</span>
                                                            </div> */}
                                                            <textarea className="form-control form-control-sm" placeholder="address..."
                                                                name="PartnerAgent_Address"
                                                                value={parameters.PartnerAgent_Address}
                                                                onChange={e => handleValue(e)}></textarea>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Country* &nbsp; &nbsp;</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="Country_Id"
                                                                value={parameters.Country_Id}
                                                                onChange={e => handleValue(e)} >
                                                                <option value="">--Select--</option>
                                                                <Country />
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card-header collapsed" >
                                            <a className="card-title">
                                                Other Details
                                            </a>
                                        </div>
                                        <div className="card-body collapse show" >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" name="Contact_Person" value={parameters.Contact_Person} onChange={e => handleValue(e)} placeholder="contact person" />

                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person Email*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <input type="text" className="form-control form-control-sm" name="Contact_Email" value={parameters.Contact_Email} onChange={e => handleValue(e)} placeholder="contact person email" />

                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Contact Person Number*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" name="Contact_Number" value={parameters.Contact_Number} onChange={e => handleValue(e)} placeholder="contact person number" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Affiliation*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select type="text" className="form-control form-control-sm" name="Affiliation" value={parameters.Affiliation} onChange={e => handleValue(e)} >
                                                                <option value="">--Select--</option>
                                                                <option value="1">On-Shore Student</option>
                                                                <option value="2">Off-Shore Student</option>
                                                                <option value="3">Both</option>

                                                            </select>

                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Affiliation Pathway*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">

                                                            <select type="text" className="form-control form-control-sm" name="Affiliation_Pathway" value={parameters.Affiliation_Pathway} onChange={e => handleValue(e)} >
                                                                <option value="">--Select--</option>
                                                                <option value="1">Direct - Online</option>
                                                                <option value="2">Direct - Offline</option>
                                                                <option value="3">Other - Online</option>
                                                                <option value="4">Other - Offline</option>

                                                            </select>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="card-header collapsed"   >
                                            <a className="card-title">
                                                Commission Details
                                            </a>
                                        </div>
                                        <div id="collapseThree" className="card-body collapse  show"  >
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Percentage PG*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="commission percentage PG" name="Commision_Percentage_PG" value={parameters.Commision_Percentage_PG} onChange={e => handleValue(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Percentage UG*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="commission percentage UG" name="Commision_Percentage_UG" value={parameters.Commision_Percentage_UG} onChange={e => handleValue(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Percentage Other*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="commission percentage Other" name="Commision_Percentage_Other" value={parameters.Commision_Percentage_Other} onChange={e => handleValue(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Including GST*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <select className="form-control form-control-sm" name="Commision_Including_GST" value={parameters.Commision_Including_GST} onChange={e => handleValue(e)} >
                                                                <option value="">--Select--</option>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </select>

                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="col-md-6">
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Split Percentage*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="split percentage" name="Split_Percentage" value={parameters.Split_Percentage} onChange={e => handleValue(e)} />

                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text">%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Commission Duration*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="commission duration" name="Commission_Duration" value={parameters.Commission_Duration} onChange={e => handleValue(e)} />

                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-sm-4">
                                                            <label className="pt-1 mb-0">Lumpsum Commision*</label>
                                                        </div>
                                                        <div className="col-sm-8 input-group input-group-sm">
                                                            <input type="text" className="form-control form-control-sm" placeholder="lumpsum commission" name="Lumpsum_Commision" value={parameters.Lumpsum_Commision} onChange={e => handleValue(e)} />

                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 text-center">
                                                    <hr />
                                                    <>
                                                        {
                                                            loadingUpdate ? (
                                                                <div className="Create-btn">
                                                                    Loading...
                                                                </div>
                                                            ) : (
                                                                <div className="Create-btn">
                                                                    <a className="btn create-contact"
                                                                        onClick={e => UpdateRecord(e)}>Update</a>
                                                                </div>
                                                            )
                                                        }
                                                    </>
                                                    <span className='text-success'>{successUpdate}</span>
                                                    <span className='text-danger'>{errorUpdate}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

